export default "/_next/static/images/6a00dbd0db70bbb0465f02cb872ec9a4.jpg";